import React from "react";
import { Box, Button, Paper, Stack, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";
import RefreshIcon from "@mui/icons-material/Refresh";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import BaseDialog from "../utils/dialog/BaseDialog";
import RolloverYearSummary from "./RolloverYearSummary";

const RolloverConfirmationDialog = ({
  open,
  sourceYear,
  targetYear,
  onClose,
  onBack,
  onConfirm,
}) => (
  <BaseDialog
    open={open}
    onClose={onClose}
    maxWidth='md'
    title='Confirm Rollover'
    subtitle='Review the source and destination before applying the rollover.'
    icon={<RefreshIcon />}
    paperSx={{ maxWidth: 780 }}
    contentSx={{ px: { xs: 2, sm: 3 } }}
    actions={
      <>
        <Button
          onClick={onBack}
          color='inherit'
          sx={{ mr: "auto", color: "text.secondary", textTransform: "none" }}
        >
          Back
        </Button>
        <Button
          variant='contained'
          color='warning'
          onClick={onConfirm}
          sx={{ textTransform: "none" }}
        >
          Start rollover
        </Button>
      </>
    }
  >
    <Stack spacing={2.5}>
      <RolloverYearSummary sourceYear={sourceYear} targetYear={targetYear} />
      <Box>
        <Typography variant='subtitle1' fontWeight={600} sx={{ mb: 1 }}>
          Before you continue
        </Typography>
        <Typography
          variant='body2'
          color='text.secondary'
          sx={{ lineHeight: 1.7 }}
        >
          Eligible balances and schedules from YA {sourceYear} will be carried
          forward to YA {targetYear}.
        </Typography>
      </Box>
      <Paper
        variant='outlined'
        sx={{
          p: 2,
          borderRadius: 2,
          bgcolor: (theme) => alpha(theme.palette.warning.main, 0.04),
          borderColor: (theme) => alpha(theme.palette.warning.main, 0.25),
        }}
      >
        <Stack direction='row' spacing={1.5} alignItems='flex-start'>
          <WarningAmberIcon
            sx={{ color: "warning.main", fontSize: 20, mt: 0.25 }}
          />
          <Box>
            <Typography variant='subtitle2' fontWeight={600} sx={{ mb: 0.5 }}>
              Current data may be overwritten
            </Typography>
            <Typography
              variant='body2'
              color='text.secondary'
              sx={{ lineHeight: 1.7 }}
            >
              Existing balances and schedules may be overwritten. If this
              computation has already been rolled over, its data will be reset
              first.
            </Typography>
            <Typography
              variant='caption'
              color='text.secondary'
              display='block'
              sx={{ mt: 1 }}
            >
              This cannot be undone.
            </Typography>
          </Box>
        </Stack>
      </Paper>
    </Stack>
  </BaseDialog>
);

export default RolloverConfirmationDialog;
